import request from '@/utils/request';
export function salesStatuslist(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/salesStatuslist',
    method: 'post',
    data: data
  });
}
export function attractStatuslist(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/attractStatuslist',
    method: 'post',
    data: data
  });
}
export function channelTypelist(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/channelTypelist',
    method: 'post',
    data: data
  });
}
export function salesStatusMonthlist(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/salesStatusMonthlist',
    method: 'post',
    data: data
  });
}
export function loselist(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/loselist',
    method: 'post',
    data: data
  });
}
export function loseMonthlist(data) {
  return request({
    url: '/pmsservice/api/attarctCustorme/loseMonthlist',
    method: 'post',
    data: data
  });
}